import { render } from "./email_staff.vue?vue&type=template&id=fb53c81e"
import script from "./email_staff.vue?vue&type=script&lang=js"
export * from "./email_staff.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__